import { cn } from "@gettactic/helpers";
import * as React from "react";

/**
 * A pulsing placeholder in the shape of content still loading; size and round it with
 * `className`.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
